import { IFilerInformation } from "../typings/models/FilerInformation";
export const helper = () => {
  const btnLoaderHandler = (enableLoader: boolean) => {
    var inputs = document.querySelectorAll(".btn-d");
    inputs.forEach(
      (input) => ((input as HTMLButtonElement).disabled = enableLoader)
    );
  };
  const DraftbtnLoaderHandler = (enableLoader: boolean) => {
    var inputs = document.querySelectorAll(".btn-d");
    inputs.forEach(
      (input) => ((input as HTMLButtonElement).disabled = enableLoader)
    );
  };

  const fileToBase64 = (file: File) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  // const getFilerInfomation = () => {
  //   const appData = localStorage.getItem("app-data");
  //   if (appData?.length) {
  //     const userInfo = JSON.parse(appData);
  //     const user = userInfo?.user;
  //     let address: IAddress = {
  //       postalCode: user?.registeredAddress?.postalCode,
  //       blockHouseNo: user?.registeredAddress?.blockHouseNo,
  //       streetName: user?.registeredAddress?.streetName,
  //       floorLevel: user?.registeredAddress?.floorLevel,
  //       unit: user?.registeredAddress?.unit,
  //       buildingName: user?.registeredAddress?.buildingName,
  //     };
  //     let filerInfo: IFilerInformation = {
  //       filerName: user?.name,
  //       nric: user?.idNo,
  //       email: user?.email,
  //       mobile: user?.mobileNumber,
  //       filerAddress: address,
  //       uen: user?.uen,
  //       companyName: user?.companyName,
  //     };
  //     return filerInfo;
  //   }
  // };

  const getFilerInfomation = () => {
    const appData = localStorage.getItem("app-data");
    if (appData?.length) {
      const userInfo = JSON.parse(appData);
      const user = userInfo?.user;

      if (
        Array.isArray(user?.registeredAddresses) &&
        user.registeredAddresses.length > 0
      ) {
        const address = user.registeredAddresses[0];

        let filerInfo: IFilerInformation = {
          filerName: user?.name,
          nric: user?.idNo,
          email: user?.email,
          mobile: user?.mobileNumber,
          filerAddress: {
            postalCode: address?.postalCode,
            blockHouseNo: address?.blockHouseNo,
            streetName: address?.streetName,
            country: address?.country,
            floorLevel: address?.floorLevel,
            unit: address?.unit,

            buildingName: address?.buildingName,
          },
          uen: user?.uen,
          companyName: user?.companyName,
        };

        return filerInfo;
      }
    }
    return null;
  };

  return {
    btnLoaderHandler: btnLoaderHandler,
    DraftbtnLoaderHandler: DraftbtnLoaderHandler,
    fileToBase64: fileToBase64,
    getFilerInfomation: getFilerInfomation,
  };
};
